module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside.246b03c3.svg";